import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL preservation: /reminders/birthday/more was the old post-import "Congrats!
// We're building your list… get more birthdays" page. Its content merged into
// /reminders/birthday/add (2026-09-28); land there with the import banner.
export const Route = createFileRoute("/reminders_/birthday_/more")({
  beforeLoad: () => {
    throw redirect({ to: "/reminders/birthday/add", search: { from: "import" }, replace: true });
  },
});
